export const FETCH_SINGLEPROJECT_REQUEST = 'FETCH_SINGLEPROJECT_REQUEST';
export const FETCH_SINGLEPROJECT_SUCCESS = 'FETCH_SINGLEPROJECT_SUCCESS';
export const FETCH_SINGLEPROJECT_FAILURE = 'FETCH_SINGLEPROJECT_FAILURE';
export const UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE';
